/**
 * The way back after the first run: one card for the canvas it landed on,
 * above the starters, with the canvas's name and when it last changed. A
 * canvas that is gone or archived hides the row.
 */

import { ROUTES } from "@/constants/routes";
import { route } from "@/utils/route";
import { formatDistanceToNow } from "date-fns";
import { Frame } from "lucide-react";
import { useNavigate } from "react-router-dom";
import { StarterCard } from "./StarterCard";
import { useStarterCanvases } from "./useStarterCanvases";

export const PICK_UP_TITLE = "Pick up where you left off";

export function PickUpRow({
  canvasId,
  cardCount,
}: {
  canvasId: string;
  /** Cards the column holds at production size; the card takes one slot. */
  cardCount: number;
}) {
  const navigate = useNavigate();
  const canvas = useStarterCanvases([canvasId])[canvasId];
  if (!canvas) return null;
  const when = `Updated ${formatDistanceToNow(new Date(canvas.updated_at), { addSuffix: true })}`;
  return (
    <div data-testid="pick-up-row" className="flex flex-col gap-3">
      <div className="flex min-h-8 items-center">
        <h2 className="text-lg font-medium text-n-90">{PICK_UP_TITLE}</h2>
      </div>
      <div className="flex py-1">
        <div className="min-w-0" style={{ flexBasis: `${100 / cardCount}%` }}>
          <StarterCard
            title={canvas.name}
            subtitle={when}
            preview={
              <div className="absolute inset-0 flex items-center justify-center bg-surface-card">
                <Frame
                  className="size-10 text-n-40"
                  strokeWidth={1.25}
                  aria-hidden
                />
              </div>
            }
            onOpen={() => navigate(route(ROUTES.CANVAS.DETAIL, { canvasId }))}
          />
        </div>
      </div>
    </div>
  );
}
